import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';

import Input from 'components/input';
import Button from 'components/button';
import defaultImg from 'assets/images/Login/LoginBG.png';
import loginLogo from 'assets/images/Login/Apollo-Portal_Login_Logo.png';

import { useLogin } from './helper';
import './style.scss';
import { useAppSelector } from 'store/hooks';
import ForgotPasswordModal from 'components/Modal/Login/ForgotPassword';

const CustomerPortalLogin = () => {
  const { isLoading, register, handleSubmit, onSubmit, errors } = useLogin();
  const { loginBackgroundImg } = useAppSelector((state) => state.AuthSplice);
  const ApiImg = loginBackgroundImg?.portal_background_image;

  const [modalOpen, setModalOpen] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);

  const togglePassword = (state) => {
    setPasswordShow(!passwordShow);
  };

  const toggleShowModal = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <>
      <div
        className="app-main min-vh-100 overflow-hidden overflow-sm-visible"
        style={{
          backgroundImage: `url(${ApiImg !== null ? ApiImg : defaultImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}>
        <div className="min-vh-100 justify-content-center d-flex align-items-center">
          <Row className="pt-5">
            <Col>
              <div className="d-flex justify-content-center mb-5">
                <img src={loginLogo || null} alt="login logo" />
              </div>
              <Row className="login-text font-Atomospheric justify-content-center pt-5">
                <Col className="login-text font-Atomospheric text-center">
                  Your Gateway to Global Communications
                </Col>
              </Row>
              <div className="background-shadow text-white text-center py-2 mx-5 mt-3 mb-4">
                <div className="welcome-text">
                  <div className="py-1">Welcome to SatPhonePortal.com</div>
                  <div className="">
                    Please log in below to access your account details.
                  </div>
                </div>
              </div>
              <Row className="justify-content-center my-4 py-3">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="position-relative" style={{ zIndex: '100' }}>
                    <svg
                      className="position-absolute "
                      style={{ zIndex: '-1', top: '3px', left: ' -6px' }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="45"
                      viewBox="0 0 19 53"
                      fill="none">
                      <path
                        d="M17 2C12 8.83333 2 22 2 26C2 30 11.3333 43.8333 16 51"
                        stroke="#1080C8"
                        stroke-width="4"
                        stroke-linecap="round"
                      />
                    </svg>
                    <Input
                      placeholder="Email address"
                      name={'email'}
                      register={register}
                      errorMessage={errors?.email?.message}
                    />
                    <svg
                      className="position-absolute "
                      style={{ zIndex: '-1', top: '-7px', left: ' 3px' }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="341"
                      height="65"
                      viewBox="0 0 341 54"
                      fill="none">
                      <path
                        d="M324.318 1.49708L324.028 1H323.453H17.5466H16.9715L16.6823 1.49708L2.13567 26.4971L1.84304 27L2.13567 27.5029L16.6823 52.5029L16.9715 53H17.5466H324.309H324.902L325.186 52.4803L338.877 27.4803L339.148 26.9851L338.864 26.4971L324.318 1.49708Z"
                        stroke="url(#paint0_linear_52_2)"
                        stroke-width="2"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_52_2"
                          x1="1.73106"
                          y1="-1.33335"
                          x2="337.752"
                          y2="52.3007"
                          gradientUnits="userSpaceOnUse">
                          <stop stop-color="#1080C8" />
                          <stop offset="0.631761" stop-color="#25F4F8" />
                          <stop offset="1" stop-color="#1080C8" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <svg
                      className="position-absolute "
                      style={{ zIndex: '-1', top: '3px', left: ' 335px' }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="45"
                      viewBox="0 0 19 53"
                      fill="none">
                      <path
                        d="M2 2C7 8.83333 17 22 17 26C17 30 7.66667 43.8333 3 51"
                        stroke="#1080C8"
                        stroke-width="4"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <div className="position-relative" style={{ zIndex: '100' }}>
                    <svg
                      className="position-absolute "
                      style={{ zIndex: '-1', top: '3px', left: ' -6px' }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="45"
                      viewBox="0 0 19 53"
                      fill="none">
                      <path
                        d="M17 2C12 8.83333 2 22 2 26C2 30 11.3333 43.8333 16 51"
                        stroke="#A1B5C6"
                        stroke-width="4"
                        stroke-linecap="round"
                      />
                    </svg>
                    {passwordShow && (
                      <svg
                        onClick={togglePassword}
                        className="position-absolute pointer"
                        style={{ right: '20px', top: '2px', zIndex: '115' }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="47"
                        viewBox="0 0 49 47"
                        fill="none">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0.717551 0.688323C1.67435 -0.2294 3.22559 -0.2294 4.18239 0.688323L48.2824 42.9884C49.2392 43.9061 49.2392 45.3941 48.2824 46.3118C47.3257 47.2295 45.7744 47.2295 44.8176 46.3118L0.717551 4.01174C-0.239224 3.094 -0.239224 1.60607 0.717551 0.688323Z"
                          fill="#416896"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12.6153 10.7239C12.0598 11.0623 11.5222 11.413 11.0036 11.7708C7.30181 14.3254 4.3613 17.3906 2.54861 19.5015C0.538117 21.8428 0.538117 25.1573 2.54861 27.4986C4.3613 29.6096 7.30181 32.6747 11.0036 35.2294C14.6861 37.7705 19.3311 39.9501 24.5005 39.9501C29.6698 39.9501 34.3147 37.7705 37.9973 35.2294C38.0294 35.2071 38.0617 35.1848 38.0938 35.1624L32.1102 29.423C30.3134 31.5446 27.5718 32.9001 24.5 32.9001C19.0876 32.9001 14.7 28.6915 14.7 23.5001C14.7 20.5536 16.1132 17.924 18.325 16.2005L12.6153 10.7239ZM34.2086 24.789C34.2689 24.3677 34.3 23.9374 34.3 23.5001C34.3 18.3086 29.9123 14.1001 24.5 14.1001C24.0441 14.1001 23.5955 14.1299 23.1562 14.1877L18.503 9.7244C17.8801 9.127 18.1005 8.11552 18.9432 7.86961C20.7069 7.35494 22.567 7.05005 24.5005 7.05005C29.6698 7.05005 34.3147 9.22961 37.9973 11.7709C41.699 14.3254 44.6395 17.3906 46.4523 19.5015C48.4627 21.8428 48.4627 25.1573 46.4523 27.4986C45.5061 28.6003 44.2529 29.9621 42.7444 31.3754C42.2731 31.8172 41.5209 31.8026 41.0549 31.3559L34.2086 24.789ZM21.8275 19.5601C20.4864 20.3985 19.6 21.8501 19.6 23.5001C19.6 26.0959 21.7937 28.2001 24.5 28.2001C26.2201 28.2001 27.7335 27.3498 28.6077 26.0635L21.8275 19.5601Z"
                          fill="#416896"
                        />
                      </svg>
                    )}
                    <Input
                      type={passwordShow ? 'text' : 'password'}
                      placeholder="password"
                      name={'password'}
                      register={register}
                      errorMessage={errors?.password?.message}
                    />
                    {!passwordShow && (
                      <svg
                        onClick={togglePassword}
                        className="position-absolute pointer"
                        style={{ right: '20px', top: '8px', zIndex: '111' }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="34"
                        viewBox="0 0 49 34"
                        fill="none">
                        <path
                          d="M18.7292 16.6667C18.7292 14.0779 21.1637 11.9792 24.1667 11.9792C27.1696 11.9792 29.6042 14.0779 29.6042 16.6667C29.6042 19.2554 27.1696 21.3542 24.1667 21.3542C21.1637 21.3542 18.7292 19.2554 18.7292 16.6667Z"
                          fill="#416896"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0 16.6667C0 20.0821 1.02699 21.2323 3.08098 23.5327C7.18224 28.1258 14.0604 33.3333 24.1667 33.3333C34.2729 33.3333 41.151 28.1258 45.2523 23.5327C47.3062 21.2323 48.3333 20.0821 48.3333 16.6667C48.3333 13.2512 47.3062 12.1011 45.2523 9.80069C41.151 5.20742 34.2729 0 24.1667 0C14.0604 0 7.18224 5.20742 3.08098 9.80069C1.02699 12.1011 0 13.2512 0 16.6667ZM24.1667 8.85417C19.1616 8.85417 15.1042 12.3519 15.1042 16.6667C15.1042 20.9815 19.1616 24.4792 24.1667 24.4792C29.1718 24.4792 33.2292 20.9815 33.2292 16.6667C33.2292 12.3519 29.1718 8.85417 24.1667 8.85417Z"
                          fill="#416896"
                        />
                      </svg>
                    )}
                    <svg
                      className="position-absolute "
                      style={{ zIndex: '-1', top: '-2px', left: ' 3px' }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="341"
                      height="54"
                      viewBox="0 0 341 54"
                      fill="none">
                      <path
                        d="M324.318 1.49708L324.028 1H323.453H17.5466H16.9715L16.6823 1.49708L2.13567 26.4971L1.84304 27L2.13567 27.5029L16.6823 52.5029L16.9715 53H17.5466H324.309H324.902L325.186 52.4803L338.877 27.4803L339.148 26.9851L338.864 26.4971L324.318 1.49708Z"
                        stroke="#A1B5C6"
                        stroke-width="2"
                      />
                    </svg>
                    <svg
                      className="position-absolute "
                      style={{ zIndex: '-1', top: '3px', left: ' 335px' }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="45"
                      viewBox="0 0 19 53"
                      fill="none">
                      <path
                        d="M2 2C7 8.83333 17 22 17 26C17 30 7.66667 43.8333 3 51"
                        stroke="#A1B5C6"
                        stroke-width="4"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <div className="mt-5 pt-3  d-flex justify-content-center">
                    <div className="loginbtn-outter">
                      <div className="loginbtn-inner"></div>
                      <Button
                        type="submit"
                        size="lg"
                        className="login-btn btn-block text-uppercase font-weight-bold font-size-sm d-flex justify-content-center align-items-center"
                        isLoading={isLoading}>
                        <span className="btn-wrapper--label mt-1">Log in</span>
                      </Button>
                      <div className="loginbtn-bottom"></div>
                    </div>
                  </div>
                </form>
              </Row>
              <Row className="mx-5">
                <Col className="mx-5">
                  <div className="background-shadow text-white text-center py-2 my-2 mx-5">
                    <div className="welcome-text">
                      <div
                        className="py-1 pointer"
                        style={{ color: '#00FBFF' }}
                        onClick={toggleShowModal}>
                        Forgot your password?
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mx-5">
                <Col className="mx-5">
                  <div className="background-shadow text-white text-center py-2 my-3 mx-5">
                    <div className="welcome-text">
                      <div className="py-1">
                        Don’t have an account yet?{' '}
                        <span style={{ color: '#00FBFF' }}>
                          Contact Your Service Provider
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>

      {modalOpen && (
        <ForgotPasswordModal toggle={toggleShowModal} modalOpen={modalOpen} />
      )}
    </>
  );
};

export default CustomerPortalLogin;
